import React, {
  ReactElement, useCallback, useEffect,
} from 'react';
import { SearchInputButton } from 'slovlex-idsk-react-components';
import PublikovanyTerminFilter from '../../../model/PublikovanyTerminFilter';
import { SafeParameterSetter } from '../../../model/SafeParameterSetter';

interface Props {
  filterCopy: PublikovanyTerminFilter;
  label?: string;
  filterSearchText: string;
  fieldName: keyof PublikovanyTerminFilter;
  onUpdateFieldCopy: SafeParameterSetter<PublikovanyTerminFilter>;
  setFilter: (filter) => void;
  className?: string;
  maxLength: number;
}

const SearchInput = ({
  filterCopy,
  label,
  filterSearchText,
  onUpdateFieldCopy,
  fieldName,
  className,
  maxLength,
  setFilter,
}: Props): ReactElement => {
  const onSubmit = useCallback(async (): Promise<void> => {
    setFilter(filterCopy);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filterCopy)]);

  useEffect(() => {
    const keyDownHandler = async (e): Promise<void> => {
      if (e.key === 'Enter') {
        e.preventDefault();
        await onSubmit();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [onSubmit]);

  return (
    <SearchInputButton
      className={className}
      label={label}
      searchText={filterSearchText}
      setSearchText={(value: string) => onUpdateFieldCopy(fieldName, value)}
      onClearSearch={() => {
        onUpdateFieldCopy(fieldName, '');
      }}
      onButtonSubmit={onSubmit}
      maxLength={maxLength}
    />
  );
};

export default SearchInput;
